/**
 * Single source of truth for public marketing-page SEO metadata
 * (RLX-FEAT-009). Consumers:
 * - scripts/prerender-solutions.mjs — static HTML head (title, description,
 *   canonical, absolute Open Graph/Twitter tags)
 * - SolutionsPage / HelpPage — document.title while the SPA route is active
 * - public/index.html — generic defaults kept in sync manually (see the
 *   comment there); absolute URLs are required for OG crawlers.
 */

export const MARKETING_ORIGIN = 'https://www.relix.delivery';

/** OG/Twitter crawlers require absolute URLs — never a relative path. */
export const MARKETING_OG_IMAGE = `${MARKETING_ORIGIN}/social/relix-og.png`;

export type MarketingPageSeo = {
  title: string;
  description: string;
  canonical: string;
};

export const marketingSeo: Record<'solutions' | 'help', MarketingPageSeo> = {
  solutions: {
    title: 'Relix — AI Delivery Intelligence Layer',
    description:
      'Know what will ship before it slips. Relix connects Jira, release plans, forecasts, commitments, capacity, and quality signals into one delivery decision layer.',
    canonical: `${MARKETING_ORIGIN}/solutions`,
  },
  help: {
    title: 'Relix Help Center — FAQ, Security & Contact',
    description:
      'Answers about connecting Jira, setup time, data security, and working with Relix — plus how to reach a human.',
    canonical: `${MARKETING_ORIGIN}/help`,
  },
} as const;
